import React, { Component } from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

class Emploi extends Component {
  state = {
    redirect:false,
    search: ''
    }

  handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

setRedirect = () => {
  this.setState({
    redirect: true
  })
}

handleSubmitFacebbok = () => {
  if (this.state.redirect) {
      window.location.href = "https://www.facebook.com/clubCAPN/";
  }
}

  handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
  }

  render () {  
    return (
      <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                  <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                      <div className="histoire-content">
                          <h1 className="hline"><span>Offres d'emploi</span></h1>   
                          <p className="pCenter">Le CAPN est à la recherche de moniteurs en sécurité aquatique! Consultez l'offre ci-dessous:</p>
                          <Col lg={12} md={12} sm={12} xs={12} className="nopadding link-emploi">
                          <a href="/Annonce_Moniteur_CAPN_2018.pdf" className="btn btn-primary btn-blue-light emploi" target="_blank" download>
                          TOUTES LES INFORMATIONS ICI
                          </a>
                        </Col>
                        <p className="pCenter">Voici un offre d'emploi pour le poste de directeur générale. Consultez l'offre ci-dessous:</p>
                          <Col lg={12} md={12} sm={12} xs={12} className="nopadding link-emploi">
                          <a href="/Description de poste_DG_VF.pdf" className="btn btn-primary btn-blue-light emploi" target="_blank" download>
                          TOUTES LES INFORMATIONS ICI
                          </a>
                        </Col>
                         
                      </div>

                      </Col>
                    </Row>
                  </Col>


              <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <div className="fixed-bottom-footer"><Footer /></div>
              </Col>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
  }

export default Emploi
